import { useState, useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { useQuery } from "@tanstack/react-query";

const graphRequest = {
  scopes: ["User.Read"], // Corrected scopes
};

const useGraphToken = () => {
  const { instance, accounts, inProgress } = useMsal();
  const [isInitialized, setIsInitialized] = useState(false);

  const getGraphToken = async () => {
    if (accounts.length > 0) {
      try {
        const response = await instance.acquireTokenSilent({
          ...graphRequest,
          account: accounts[0],
        });
        return response.accessToken;
      } catch (error: any) {
        console.warn("Silent Graph token acquisition failed", error);
        if (error.errorCode === "interaction_required") {
          try {
            const response = await instance.acquireTokenPopup(graphRequest);
            return response.accessToken;
          } catch (popupError) {
            console.error(
              "Interactive login failed for Graph token",
              popupError
            );
            return null;
          }
        } else {
          console.error("Token acquisition failed", error);
          return null;
        }
      }
    }
    return null;
  };

  useEffect(() => {
    if (inProgress === "none") {
      setIsInitialized(true);
    }
  }, [inProgress]);

  const { data: graphToken, isLoading } = useQuery({
    queryKey: ["graphToken"],
    queryFn: getGraphToken,
    enabled: isInitialized && accounts.length > 0,
    staleTime: 30 * 60 * 1000, // 30 minutes
  });

  return { graphToken, isLoading, isInitialized };
};

export default useGraphToken;
